import "core-js/modules/es.array.map.js";
/* eslint-disable react/prop-types */
import React from 'react';
import { Link, Breadcrumbs as MuiBreadcrumbs } from '@material-ui/core';
import { _SeparatorWrapper, _SeparatorWrapperWhite, useStyles } from "./styles";
import SeparatorIcon from "../../icons/ArrowChevronDown";
function Separator(_ref) {
  var color = _ref.color;
  if (color === 'white') {
    return /*#__PURE__*/React.createElement(_SeparatorWrapperWhite, null, /*#__PURE__*/React.createElement(SeparatorIcon, null));
  }
  return /*#__PURE__*/React.createElement(_SeparatorWrapper, null, /*#__PURE__*/React.createElement(SeparatorIcon, null));
}
export function Breadcrumbs(_ref2) {
  var color = _ref2.color,
    crumbs = _ref2.crumbs,
    linkComponent = _ref2.linkComponent;
  var _useStyles = useStyles(),
    linkStyle = _useStyles.linkStyle,
    titleStyle = _useStyles.titleStyle;
  return /*#__PURE__*/React.createElement(MuiBreadcrumbs, {
    separator: /*#__PURE__*/React.createElement(Separator, {
      color: color
    }),
    "aria-label": "breadcrumb"
  }, crumbs.map(function (crumb, i) {
    if (!crumb.href) {
      return /*#__PURE__*/React.createElement("span", {
        key: "crumb_".concat(i),
        color: "inherit",
        className: color === 'white' ? titleStyle : ''
      }, crumb.text);
    }
    return /*#__PURE__*/React.createElement(Link, {
      key: "crumb_".concat(i),
      color: "inherit",
      underline: "none",
      href: crumb.href,
      to: crumb.href,
      onClick: crumb.onClick,
      component: linkComponent,
      className: color === 'white' ? linkStyle : ''
    }, crumb.text);
  }));
}
Breadcrumbs.defaultProps = {
  crumbs: []
};
export default Breadcrumbs;